var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSeatbeltTeal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".d{fill:#004a5d;}.e{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M2,12.31v-.62c0-.64,.06-1.27,.19-1.89s.31-1.23,.55-1.82c.24-.59,.54-1.15,.9-1.67,.35-.53,.75-1.02,1.2-1.47s.94-.85,1.47-1.2c.53-.35,1.09-.65,1.67-.9,.59-.24,1.19-.43,1.82-.55,.62-.12,1.25-.19,1.89-.19h.62c.64,0,1.27,.06,1.89,.19,.62,.12,1.23,.31,1.82,.55,.59,.24,1.15,.54,1.67,.9s1.02,.75,1.47,1.2c.45,.45,.85,.94,1.2,1.47,.35,.53,.65,1.09,.9,1.67,.24,.59,.43,1.19,.55,1.82,.12,.62,.19,1.25,.19,1.89v.62c0,.64-.06,1.27-.19,1.89-.12,.62-.31,1.23-.55,1.82-.24,.59-.54,1.15-.9,1.67s-.75,1.02-1.2,1.47-.94,.85-1.47,1.2-1.09,.65-1.67,.9c-.59,.24-1.19,.43-1.82,.55-.62,.12-1.25,.19-1.89,.19h-.62c-.64,0-1.27-.06-1.89-.19-.62-.12-1.23-.31-1.82-.55-.59-.24-1.15-.54-1.67-.9-.53-.35-1.02-.75-1.47-1.2-.45-.45-.85-.94-1.2-1.47s-.65-1.09-.9-1.67c-.24-.59-.43-1.19-.55-1.82-.12-.62-.19-1.25-.19-1.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M12,3c4.96,0,9,4.04,9,9s-4.04,9-9,9S3,16.96,3,12,7.04,3,12,3m0-3C5.37,0,0,5.37,0,12s5.37,12,12,12,12-5.37,12-12S18.63,0,12,0h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M14.32,8.25c-.13-.03-.26-.06-.4-.06h-3.88c-.88,0-1.61,.74-1.65,1.68l-.15,3.62,6.08-5.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M14.79,14.31c.34,0,.66,.04,.97,.09l-.19-4.52c-.01-.22-.06-.42-.14-.61l-5.85,5.05h5.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M16.38,16.75c-.03-.09-.06-.17-.1-.25-.02-.04-.04-.07-.06-.1-.05-.08-.1-.16-.17-.23-.02-.02-.04-.05-.06-.07-.09-.09-.18-.18-.29-.25h0c-.26-.18-.58-.28-.92-.28h-5.59c-.35,0-.68,.11-.95,.3h0c-.1,.07-.19,.15-.27,.24-.02,.02-.04,.05-.06,.07-.06,.07-.11,.14-.16,.22-.02,.03-.04,.07-.06,.1-.04,.08-.07,.16-.1,.25-.01,.04-.02,.07-.03,.11-.03,.12-.05,.25-.05,.38v.93c0,.41,.33,.74,.74,.74h7.44c.41,0,.74-.33,.74-.74v-.93c0-.13-.02-.26-.05-.38,0-.04-.02-.07-.03-.11Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M12,4.55c-.86,0-1.56,.7-1.56,1.56v.69c0,.86,.7,1.56,1.56,1.56s1.56-.7,1.56-1.56v-.69c0-.86-.7-1.56-1.56-1.56Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeatbeltTeal);
export default __webpack_public_path__ + "static/media/seatbelt-teal.0f5a6585a6a97269c3342b13e15b84c8.svg";
export { ForwardRef as ReactComponent };